/** Admin accounts — list, detail, deactivate, reactivate, delete, revoke single membership. */
import { apiDelete, apiGet, apiPost } from '../client.js';
import type { Account, AccountDetail } from '../types.js';

export function listAccounts(): Promise<Account[]> {
  return apiGet<Account[]>('/api/v1/admin/accounts');
}

export function getAccount(externalSub: string): Promise<AccountDetail> {
  return apiGet<AccountDetail>(`/api/v1/admin/accounts/${encodeURIComponent(externalSub)}`);
}

export function revokeMembership(externalSub: string, orgId: string): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/accounts/${encodeURIComponent(externalSub)}/memberships/${encodeURIComponent(orgId)}`,
  );
}

export function deactivateAccount(externalSub: string): Promise<Account> {
  return apiPost<Account>(
    `/api/v1/admin/accounts/${encodeURIComponent(externalSub)}/deactivate`,
    {},
  );
}

export function reactivateAccount(externalSub: string): Promise<Account> {
  return apiPost<Account>(
    `/api/v1/admin/accounts/${encodeURIComponent(externalSub)}/reactivate`,
    {},
  );
}

/** Hard-delete. Backend returns 409 unless the account is fully inactive. */
export function deleteAccount(externalSub: string): Promise<void> {
  return apiDelete<void>(`/api/v1/admin/accounts/${encodeURIComponent(externalSub)}`);
}
